import { render, staticRenderFns } from "./newslist.vue?vue&type=template&id=ba4274a2&scoped=true&"
import script from "./newslist.vue?vue&type=script&lang=js&"
export * from "./newslist.vue?vue&type=script&lang=js&"
import style0 from "./newslist.vue?vue&type=style&index=0&id=ba4274a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4274a2",
  null
  
)

export default component.exports